// extracted by mini-css-extract-plugin
export default {"link":"navButton_link__Z3h+3","newCollection":"navButton_newCollection__ZtOqU","skew":"navButton_skew__-AYDL"};